<template>
  <div id="app">
    <v-app>
      <router-view style="height: 100%"></router-view>
      <DialogComponent></DialogComponent>
      <FolderPermissionsDialog></FolderPermissionsDialog>
      <AdminPanel></AdminPanel>
      <UploadDialog></UploadDialog>
    </v-app>
  </div>
</template>

<script>

export default {
  props: {},
  data: () => {
    return {};
  },
  computed: {},
  watch: {},
  mounted() {
    this.$store.state.loadAuthUser();
    this.$store.state.initRequests();
    this.$store.dispatch("connect");
    this.log("app.vue", this);
    // setInterval(() => {
    //   window.location.reload();
    //   window.log("Reload-Interval")
    // }, 5000);
  },
  beforeDestroy() {},
  methods: {},
};
</script>
